import { differenceInMonths } from "date-fns";
import moment from "moment";

const aviationAllTimeValues = [
  {
    behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
    behaviourName: "Reduced Engine Taxi Out",
    behaviourAcronym: "RETO",
    behaviourPosition: 1,
    countEventsPerformablePreSignol: 175087,
    countEventsPerformablePostSignol: 152793,
    countEventsPerformedPreSignol: 37076,
    countEventsPerformedPostSignol: 52102,
    avgSuccessRatePreSignolWeighted: {
      value: 21.2,
      standardError68: 0.1,
      standardError95: 0.2,
    },
    avgSuccessRatePostSignolWeighted: {
      value: 34.1,
      standardError68: 0.1,
      standardError95: 0.2,
    },
    avgSuccessRateChange: {
      value: 12.9,
      standardError68: 0.1,
      standardError95: 0.3,
    },
  },
  {
    behaviourKey: "REDUCED_ENGINE_TAXI_IN",
    behaviourName: "Reduced Engine Taxi In",
    behaviourAcronym: "RETI",
    behaviourPosition: 2,
    countEventsPerformablePreSignol: 207412,
    countEventsPerformablePostSignol: 213788,
    countEventsPerformedPreSignol: 104743,
    countEventsPerformedPostSignol: 151576,
    avgSuccessRatePreSignolWeighted: {
      value: 50.5,
      standardError68: 0.1,
      standardError95: 0.2,
    },
    avgSuccessRatePostSignolWeighted: {
      value: 70.9,
      standardError68: 0.1,
      standardError95: 0.2,
    },
    avgSuccessRateChange: {
      value: 20.4,
      standardError68: 0.1,
      standardError95: 0.2,
    },
  },
  {
    behaviourKey: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
    behaviourName: "Optimal Discretionary Fuel Load",
    behaviourAcronym: "ODFL",
    behaviourPosition: 3,
    countEventsPerformablePreSignol: 131902,
    countEventsPerformablePostSignol: 120852,
    countEventsPerformedPreSignol: 80592,
    countEventsPerformedPostSignol: 90034,
    avgSuccessRatePreSignolWeighted: {
      value: 61.1,
      standardError68: 0.1,
      standardError95: 0.3,
    },
    avgSuccessRatePostSignolWeighted: {
      value: 74.5,
      standardError68: 0.1,
      standardError95: 0.2,
    },
    avgSuccessRateChange: {
      value: 13.4,
      standardError68: 0.2,
      standardError95: 0.4,
    },
  },
  {
    behaviourKey: "EFFICIENT_FLIGHT",
    behaviourName: "Efficient Flight",
    behaviourAcronym: "EF",
    behaviourPosition: 4,
    countEventsPerformablePreSignol: 198202,
    countEventsPerformablePostSignol: 223111,
    countEventsPerformedPreSignol: 81461,
    countEventsPerformedPostSignol: 119587,
    avgSuccessRatePreSignolWeighted: {
      value: 41.1,
      standardError68: 0.1,
      standardError95: 0.2,
    },
    avgSuccessRatePostSignolWeighted: {
      value: 53.6,
      standardError68: 0.1,
      standardError95: 0.2,
    },
    avgSuccessRateChange: {
      value: 12.5,
      standardError68: 0.1,
      standardError95: 0.2,
    },
  },
  {
    behaviourKey: "DELAYED_FLAPS_APPROACH",
    behaviourName: "Delayed Flaps Approach",
    behaviourAcronym: "DFA",
    behaviourPosition: 5,
    countEventsPerformablePreSignol: 125087,
    countEventsPerformablePostSignol: 72793,
    countEventsPerformedPreSignol: 27076,
    countEventsPerformedPostSignol: 22102,
    avgSuccessRatePreSignolWeighted: {
      value: 34.0,
      standardError68: 1.2,
      standardError95: 2.5,
    },
    avgSuccessRatePostSignolWeighted: {
      value: 30.1,
      standardError68: 2.4,
      standardError95: 4.9,
    },
    avgSuccessRateChange: {
      value: -3.9,
      standardError68: 3.5,
      standardError95: 6.9,
    },
  },
];

const aviationMonthyValues = {
  [moment.utc().subtract(1, "month").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_FLIGHT",
      behaviourName: "Efficient Flight",
      behaviourAcronym: "EF",
      behaviourPosition: 4,
      countEventsPerformablePreSignol: 198202,
      countEventsPerformablePostSignol: 10551,
      countEventsPerformedPreSignol: 81461,
      countEventsPerformedPostSignol: 5508,
      avgSuccessRatePreSignolWeighted: {
        value: 41.1,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 52.2,
        standardError68: 0.4,
        standardError95: 0.8,
      },
      avgSuccessRateChange: {
        value: 11.1,
        standardError68: 0.4,
        standardError95: 0.9,
      },
    },
    {
      behaviourKey: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
      behaviourName: "Optimal Discretionary Fuel Load",
      behaviourAcronym: "ODFL",
      behaviourPosition: 3,
      countEventsPerformablePreSignol: 131902,
      countEventsPerformablePostSignol: 10747,
      countEventsPerformedPreSignol: 80592,
      countEventsPerformedPostSignol: 7910,
      avgSuccessRatePreSignolWeighted: {
        value: 61.1,
        standardError68: 0.1,
        standardError95: 0.3,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 73.6,
        standardError68: 0.4,
        standardError95: 0.9,
      },
      avgSuccessRateChange: {
        value: 12.5,
        standardError68: 0.5,
        standardError95: 0.9,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_IN",
      behaviourName: "Reduced Engine Taxi In",
      behaviourAcronym: "RETI",
      behaviourPosition: 2,
      countEventsPerformablePreSignol: 207412,
      countEventsPerformablePostSignol: 9420,
      countEventsPerformedPreSignol: 104743,
      countEventsPerformedPostSignol: 6547,
      avgSuccessRatePreSignolWeighted: {
        value: 50.5,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 69.5,
        standardError68: 0.2,
        standardError95: 0.3,
      },
      avgSuccessRateChange: {
        value: 19.0,
        standardError68: 0.1,
        standardError95: 0.2,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
      behaviourName: "Reduced Engine Taxi Out",
      behaviourAcronym: "RETO",
      behaviourPosition: 1,
      countEventsPerformablePreSignol: 175087,
      countEventsPerformablePostSignol: 6208,
      countEventsPerformedPreSignol: 37076,
      countEventsPerformedPostSignol: 2042,
      avgSuccessRatePreSignolWeighted: {
        value: 21.2,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 32.9,
        standardError68: 0.5,
        standardError95: 1,
      },
      avgSuccessRateChange: {
        value: 11.7,
        standardError68: 0.5,
        standardError95: 1,
      },
    },
    {
      behaviourKey: "DELAYED_FLAPS_APPROACH",
      behaviourName: "Delayed Flaps Approach",
      behaviourAcronym: "DFA",
      behaviourPosition: 5,
      countEventsPerformablePreSignol: 125087,
      countEventsPerformablePostSignol: 72793,
      countEventsPerformedPreSignol: 27076,
      countEventsPerformedPostSignol: 22102,
      avgSuccessRatePreSignolWeighted: {
        value: 34.0,
        standardError68: 1.2,
        standardError95: 2.5,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 30.1,
        standardError68: 2.4,
        standardError95: 4.9,
      },
      avgSuccessRateChange: {
        value: -3.9,
        standardError68: 3.5,
        standardError95: 6.9,
      },
    },
  ],
  [moment.utc().subtract(2, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_FLIGHT",
      behaviourName: "Efficient Flight",
      behaviourAcronym: "EF",
      behaviourPosition: 4,
      countEventsPerformablePreSignol: 198202,
      countEventsPerformablePostSignol: 7540,
      countEventsPerformedPreSignol: 81461,
      countEventsPerformedPostSignol: 3891,
      avgSuccessRatePreSignolWeighted: {
        value: 41.1,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 51.6,
        standardError68: 0.4,
        standardError95: 0.8,
      },
      avgSuccessRateChange: {
        value: 10.5,
        standardError68: 0.4,
        standardError95: 0.8,
      },
    },
    {
      behaviourKey: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
      behaviourName: "Optimal Discretionary Fuel Load",
      behaviourAcronym: "ODFL",
      behaviourPosition: 3,
      countEventsPerformablePreSignol: 131902,
      countEventsPerformablePostSignol: 7540,
      countEventsPerformedPreSignol: 80592,
      countEventsPerformedPostSignol: 5451,
      avgSuccessRatePreSignolWeighted: {
        value: 61.1,
        standardError68: 0.1,
        standardError95: 0.3,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 72.3,
        standardError68: 0.4,
        standardError95: 0.8,
      },
      avgSuccessRateChange: {
        value: 11.2,
        standardError68: 0.4,
        standardError95: 0.9,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_IN",
      behaviourName: "Reduced Engine Taxi In",
      behaviourAcronym: "RETI",
      behaviourPosition: 2,
      countEventsPerformablePreSignol: 207412,
      countEventsPerformablePostSignol: 5846,
      countEventsPerformedPreSignol: 104743,
      countEventsPerformedPostSignol: 3987,
      avgSuccessRatePreSignolWeighted: {
        value: 50.5,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 68.2,
        standardError68: 0.2,
        standardError95: 0.3,
      },
      avgSuccessRateChange: {
        value: 17.7,
        standardError68: 0.1,
        standardError95: 0.2,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
      behaviourName: "Reduced Engine Taxi Out",
      behaviourAcronym: "RETO",
      behaviourPosition: 1,
      countEventsPerformablePreSignol: 175087,
      countEventsPerformablePostSignol: 3579,
      countEventsPerformedPreSignol: 37076,
      countEventsPerformedPostSignol: 1116,
      avgSuccessRatePreSignolWeighted: {
        value: 21.2,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 31.2,
        standardError68: 0.8,
        standardError95: 1.5,
      },
      avgSuccessRateChange: {
        value: 10,
        standardError68: 0.8,
        standardError95: 1.5,
      },
    },
  ],
  [moment.utc().subtract(3, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_FLIGHT",
      behaviourName: "Efficient Flight",
      behaviourAcronym: "EF",
      behaviourPosition: 4,
      countEventsPerformablePreSignol: 198202,
      countEventsPerformablePostSignol: 9048,
      countEventsPerformedPreSignol: 81461,
      countEventsPerformedPostSignol: 4560,
      avgSuccessRatePreSignolWeighted: {
        value: 41.1,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 50.4,
        standardError68: 0.3,
        standardError95: 0.6,
      },
      avgSuccessRateChange: {
        value: 9.3,
        standardError68: 0.3,
        standardError95: 0.6,
      },
    },
    {
      behaviourKey: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
      behaviourName: "Optimal Discretionary Fuel Load",
      behaviourAcronym: "ODFL",
      behaviourPosition: 3,
      countEventsPerformablePreSignol: 131902,
      countEventsPerformablePostSignol: 9048,
      countEventsPerformedPreSignol: 80592,
      countEventsPerformedPostSignol: 6469,
      avgSuccessRatePreSignolWeighted: {
        value: 61.1,
        standardError68: 0.1,
        standardError95: 0.3,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 71.5,
        standardError68: 0.5,
        standardError95: 0.9,
      },
      avgSuccessRateChange: {
        value: 10.4,
        standardError68: 0.5,
        standardError95: 1,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_IN",
      behaviourName: "Reduced Engine Taxi In",
      behaviourAcronym: "RETI",
      behaviourPosition: 2,
      countEventsPerformablePreSignol: 207412,
      countEventsPerformablePostSignol: 7535,
      countEventsPerformedPreSignol: 104743,
      countEventsPerformedPostSignol: 4981,
      avgSuccessRatePreSignolWeighted: {
        value: 50.5,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 66.1,
        standardError68: 0.2,
        standardError95: 0.3,
      },
      avgSuccessRateChange: {
        value: 15.6,
        standardError68: 0.1,
        standardError95: 0.2,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
      behaviourName: "Reduced Engine Taxi Out",
      behaviourAcronym: "RETO",
      behaviourPosition: 1,
      countEventsPerformablePreSignol: 175087,
      countEventsPerformablePostSignol: 4534,
      countEventsPerformedPreSignol: 37076,
      countEventsPerformedPostSignol: 1319,
      avgSuccessRatePreSignolWeighted: {
        value: 21.2,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 29.1,
        standardError68: 0.6,
        standardError95: 1.2,
      },
      avgSuccessRateChange: {
        value: 7.9,
        standardError68: 0.6,
        standardError95: 1.1,
      },
    },
  ],
  [moment.utc().subtract(4, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_FLIGHT",
      behaviourName: "Efficient Flight",
      behaviourAcronym: "EF",
      behaviourPosition: 4,
      countEventsPerformablePreSignol: 198202,
      countEventsPerformablePostSignol: 9802,
      countEventsPerformedPreSignol: 81461,
      countEventsPerformedPostSignol: 4803,
      avgSuccessRatePreSignolWeighted: {
        value: 41.1,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 49,
        standardError68: 0.4,
        standardError95: 0.8,
      },
      avgSuccessRateChange: {
        value: 7.9,
        standardError68: 0.4,
        standardError95: 0.8,
      },
    },
    {
      behaviourKey: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
      behaviourName: "Optimal Discretionary Fuel Load",
      behaviourAcronym: "ODFL",
      behaviourPosition: 3,
      countEventsPerformablePreSignol: 131902,
      countEventsPerformablePostSignol: 9430,
      countEventsPerformedPreSignol: 80592,
      countEventsPerformedPostSignol: 6686,
      avgSuccessRatePreSignolWeighted: {
        value: 61.1,
        standardError68: 0.1,
        standardError95: 0.3,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 70.9,
        standardError68: 0.4,
        standardError95: 0.8,
      },
      avgSuccessRateChange: {
        value: 9.8,
        standardError68: 0.5,
        standardError95: 0.9,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_IN",
      behaviourName: "Reduced Engine Taxi In",
      behaviourAcronym: "RETI",
      behaviourPosition: 2,
      countEventsPerformablePreSignol: 207412,
      countEventsPerformablePostSignol: 9234,
      countEventsPerformedPreSignol: 104743,
      countEventsPerformedPostSignol: 5827,
      avgSuccessRatePreSignolWeighted: {
        value: 50.5,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 63.1,
        standardError68: 0.2,
        standardError95: 0.3,
      },
      avgSuccessRateChange: {
        value: 12.6,
        standardError68: 0.1,
        standardError95: 0.2,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
      behaviourName: "Reduced Engine Taxi Out",
      behaviourAcronym: "RETO",
      behaviourPosition: 1,
      countEventsPerformablePreSignol: 175087,
      countEventsPerformablePostSignol: 4338,
      countEventsPerformedPreSignol: 37076,
      countEventsPerformedPostSignol: 1171,
      avgSuccessRatePreSignolWeighted: {
        value: 21.2,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 27.0,
        standardError68: 0.7,
        standardError95: 1.4,
      },
      avgSuccessRateChange: {
        value: 5.8,
        standardError68: 0.7,
        standardError95: 1.5,
      },
    },
  ],
  [moment.utc().subtract(5, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_FLIGHT",
      behaviourName: "Efficient Flight",
      behaviourAcronym: "EF",
      behaviourPosition: 4,
      countEventsPerformablePreSignol: 198202,
      countEventsPerformablePostSignol: 10556,
      countEventsPerformedPreSignol: 81461,
      countEventsPerformedPostSignol: 4982,
      avgSuccessRatePreSignolWeighted: {
        value: 41.1,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 47.2,
        standardError68: 0.3,
        standardError95: 0.6,
      },
      avgSuccessRateChange: {
        value: 6.1,
        standardError68: 0.3,
        standardError95: 0.7,
      },
    },
    {
      behaviourKey: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
      behaviourName: "Optimal Discretionary Fuel Load",
      behaviourAcronym: "ODFL",
      behaviourPosition: 3,
      countEventsPerformablePreSignol: 131902,
      countEventsPerformablePostSignol: 10370,
      countEventsPerformedPreSignol: 80592,
      countEventsPerformedPostSignol: 7166,
      avgSuccessRatePreSignolWeighted: {
        value: 61.1,
        standardError68: 0.1,
        standardError95: 0.3,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 69.1,
        standardError68: 0.4,
        standardError95: 0.8,
      },
      avgSuccessRateChange: {
        value: 8.0,
        standardError68: 0.4,
        standardError95: 0.8,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_IN",
      behaviourName: "Reduced Engine Taxi In",
      behaviourAcronym: "RETI",
      behaviourPosition: 2,
      countEventsPerformablePreSignol: 207412,
      countEventsPerformablePostSignol: 8862,
      countEventsPerformedPreSignol: 104743,
      countEventsPerformedPostSignol: 5406,
      avgSuccessRatePreSignolWeighted: {
        value: 50.5,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 61.0,
        standardError68: 0.2,
        standardError95: 0.3,
      },
      avgSuccessRateChange: {
        value: 10.5,
        standardError68: 0.1,
        standardError95: 0.2,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
      behaviourName: "Reduced Engine Taxi Out",
      behaviourAcronym: "RETO",
      behaviourPosition: 1,
      countEventsPerformablePreSignol: 175087,
      countEventsPerformablePostSignol: 6233,
      countEventsPerformedPreSignol: 37076,
      countEventsPerformedPostSignol: 1589,
      avgSuccessRatePreSignolWeighted: {
        value: 21.2,
        standardError68: 0.1,
        standardError95: 0.2,
      },
      avgSuccessRatePostSignolWeighted: {
        value: 25.5,
        standardError68: 0.5,
        standardError95: 0.9,
      },
      avgSuccessRateChange: {
        value: 4.3,
        standardError68: 0.5,
        standardError95: 0.9,
      },
    },
  ],
};

export const getSuccessRateVsPreSignolRespAviation = (
  teamId,
  startDate,
  endDate,
) => {
  let data = aviationAllTimeValues;
  if (startDate || endDate) {
    let monthsAgo =
      differenceInMonths(new Date(), new Date(endDate || startDate)) + 1;
    monthsAgo = monthsAgo > 5 ? 5 : monthsAgo; // just return the fifth month for any months further back in time
    data =
      aviationMonthyValues[
        moment.utc().subtract(monthsAgo, "months").format("YYYY/MM/DD")
      ];
  }
  return data;
};
